import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View as FoundationsView } from 'foundations-components/components/View';
import { TicketListingsSortPopover } from './TicketListingsSortPopover';
import { FilterPopover } from './TicketListingsFilterPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsMobile } from '../hooks/useBreakpoint';
import styled from 'foundations-theming-specialty/utils';
import { MOBILE_BREAKPOINT } from '../constants';
import { ViewToggleSwitch } from './ViewToggleSwitch';
import { View } from 'foundations-components/transitional/components/View';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { useTicketListingsHeading } from '../hooks/useTicketListingsHeading';
import { CreateTicketButton } from './CreateTicketButton';
import { TicketListingsSearch } from './TicketListingsSearch';
import { CsvExportButton } from './CsvExportButton';
import { MobileNavigationMenu } from './MobileNavigationMenu';
import { PageLinks } from './PageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterBarWrapper = styled.div.withConfig({
  displayName: "TicketListingsHeader__FilterBarWrapper"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:space-between;gap:", ";margin-block-start:", ";margin-block-end:", ";@media (min-width:", "px){flex-direction:row;align-items:center;flex-wrap:wrap;gap:", ";}"], ({
  theme
}) => theme.space[200], ({
  theme
}) => theme.space[400], ({
  theme
}) => theme.space[800], MOBILE_BREAKPOINT, ({
  theme
}) => theme.space[600]);
export function TicketListingsHeader({
  totalCount
}) {
  const {
    view,
    setView
  } = useTicketListingsSortAndFilters();
  const isMobile = useIsMobile();
  const ticketListingsHeading = useTicketListingsHeading();
  if (isMobile) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          "data-test-id": "ticket-listings-heading",
          typography: "body-500",
          color: "text-core-default",
          children: ticketListingsHeading
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "400",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CreateTicketButton, {})
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CsvExportButton, {})
          }), /*#__PURE__*/_jsx(MobileNavigationMenu, {})]
        })]
      }), /*#__PURE__*/_jsx(TicketListingsSearch, {
        screen: "ticket-listings",
        clearable: false,
        inlineSize: "100%"
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(FilterPopover, {}), /*#__PURE__*/_jsx(TicketListingsSortPopover, {})]
        }), /*#__PURE__*/_jsx(Text, {
          typography: "link-100",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.records",
            options: {
              count: totalCount || 0
            }
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingBlock: "25",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-500",
        "data-test-id": "ticket-listings-heading",
        color: "text-core-default",
        children: ticketListingsHeading
      }), /*#__PURE__*/_jsx(PageLinks, {})]
    }), /*#__PURE__*/_jsx(FoundationsView, {
      marginBlock: "200",
      borderBlockStartWidth: "100",
      borderBlockStartStyle: "solid",
      borderColor: "border-core-subtle"
    }), /*#__PURE__*/_jsxs(FilterBarWrapper, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "400",
        children: [/*#__PURE__*/_jsx(TicketListingsSearch, {
          screen: "ticket-listings",
          clearable: true,
          inlineSize: "370px",
          marginInlineEnd: "400"
        }), /*#__PURE__*/_jsx(FilterPopover, {}), /*#__PURE__*/_jsx(TicketListingsSortPopover, {})]
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "600",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "link-100",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "records-count",
            message: "customer-portal-app.records",
            options: {
              count: totalCount
            }
          })
        }), /*#__PURE__*/_jsx(ViewToggleSwitch, {
          view: view,
          onChange: setView
        }), /*#__PURE__*/_jsx(CsvExportButton, {}), /*#__PURE__*/_jsx(CreateTicketButton, {})]
      })]
    })]
  });
}